import type { AxiosInstance } from 'axios';
import type { ApiListingItem } from 'src/types/listing';

import { useQuery, queryOptions } from '@tanstack/react-query';

import axios from 'src/utils/axios';
import { READ_TIMEOUT_MS } from 'src/utils/requestError';

import { QueryKeys } from './QueryKeys';
import { LIVE_STALE_TIME } from './staleness';
import { askUnlessServerAnswered } from './serverRendered';

/** A car for sale as a query (`GET /buyer/listings/:id`) — asked by the hook below and by the server's render of its page. */
export const listingQuery = (id: string, http: Pick<AxiosInstance, 'get'> = axios) =>
  queryOptions({
    queryKey: QueryKeys.listing(id),
    queryFn: async (): Promise<ApiListingItem> => {
      // One segment of the path, whatever the address held: `..%2F` must not walk to another.
      const response = await http.get<ApiListingItem>(`/buyer/listings/${encodeURIComponent(id)}`, {
        timeout: READ_TIMEOUT_MS,
      });
      return response.data;
    },
    staleTime: LIVE_STALE_TIME,
  });

export function useListing(id: string) {
  return useQuery({ ...listingQuery(id), refetchOnMount: askUnlessServerAnswered });
}
